var map = {
	"./additional_products_services.png": 2128,
	"./bulb.png": 42403,
	"./bundling.png": 93595,
	"./compelling_offer.png": 2445,
	"./customer_databasing.png": 70720,
	"./data_tracking_reporting.png": 28411,
	"./database_reactivation_campaign.png": 60726,
	"./down_sells.png": 71225,
	"./email_marketing.png": 6154,
	"./financial_awareness.png": 52641,
	"./legal_business_structure.png": 33648,
	"./optimize_conversions.png": 86377,
	"./pay_per_click_advertising.png": 68484,
	"./position_of_market_dominance.png": 30495,
	"./price_increase.png": 56856,
	"./reducing_costs_and_inefficiencies.png": 68535,
	"./referral_strategy_campaign.png": 75091,
	"./reputation_management.png": 1535,
	"./risk_reversal.png": 84102,
	"./scheduling_freedom.png": 40582,
	"./search_presence_user_experience.png": 59121,
	"./strategic_partnership_alliances.png": 4016,
	"./upsell_cross_sells.png": 56330,
	"./variable_cost.png": 85087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14955;